import React from 'react';
import SocialAppContain from '../../Componant/SocialApp';

const SocialApp = () => {
  return (
    <div className='page-body'>
      <SocialAppContain />
    </div>
  );
};

export default SocialApp;
